const AnimationController = require('../animation-controller/script.js');
const ContentController = require('../page-content-controller/script.js');
const HeroController = require('../page-hero-controller/script.js');

const BaseModule = require('../../90_utils/base/BaseModule');
const Loader = require('../../90_utils/Loader');

class SiteController extends BaseModule {

	constructor(el, params) {

		super(el);

		this.$controls = this.$el.find('.controls');
		this.$prevArrow = this.$controls.find('.prev');
		this.$nextArrow = this.$controls.find('.next');
		this.$progressBar = this.$el.find('.progress-bar');
		this.$progressBarInner = this.$el.find('.progress-bar .bar-progress');

		this.$currentContent = this.$el.find('.content');
		this.$currentHero = this.$el.find('.hero');

		// tallies

		this.pageIndex = -1;
		this.pageId;
		this.sectionId;

		// flags

		this.isTrans = false;
		this.isFirstPage = true;
		this.isScrollSwap = false;
		this.isInitialized = false;

		// settings

		this.minLoadTime = 1000;
		this.loadTimeStart;
		this.loadTimeout;

		// configuration

		this.data = {

			pages : [

			  {
			  	id : 'intro',
			    title : 'Intro',
			    content : {
			      isHidden : true
			    }

			  },

			  {
			  	id : 'vision',
			    title : 'Vision',
			    content : {

			    }
			  },

			 {
			 	id : 'action',
			    title : 'Action',
			    content : {

			    }
			  },

			  {
			  	id : 'impact',
			    title : 'Impact',
			    content : {

			    }
			  }
			]
		};

		// controllers

		this.$contentController = $('#page-content-controller');
		this.$heroController = $('#page-hero-controller');

		this.animationController = new AnimationController(this.$el, {data: this.data});
		this.contentController = new ContentController(this.$contentController, {data: this.data});
		this.heroController = new HeroController(this.$heroController, {data: this.data});
	}

	// init

	init(){
		if(!this.isInitialized){
			this._loadSiteTemplates();
			this.isInitialized = true;
		}
	}

	// private methods

	_domReady(){
		this.init();
	}

	_addListeners(){

		this.$controls.find('.next').on('click', this._onNextClick.bind(this));
		this.$controls.find('.prev').on('click', this._onPrevClick.bind(this));

		window.vent.on('silentRoute', this._onSilentRoute, this);
		window.vent.on('heroChangeRoute', this._onHeroChangeRoute, this);
		window.vent.on('linkChangeRoute', this._onLinkChangeRoute, this);
		window.vent.on('changePageContent', this._onChangePageContent, this);
		window.vent.on('pageChangeStart', this._onPageChangeStart, this);
		window.vent.on('pageChangeComplete', this._onPageChangeComplete, this);
		window.vent.on('pagePopulate', this._onPagePopulate, this);
		window.vent.on('pagePopulateComplete', this._onPagePopulateComplete, this);
		window.vent.on('pageTransitionOutComplete', this._onPageTransitionOutComplete, this);
		window.vent.on('pageTransitionInComplete', this._onPageTransitionInComplete, this);

		window.vent.on('pageLoadStart', this._onPageLoadStart, this);
		window.vent.on('pageLoadUpdate', this._onPageLoadUpdate, this);
		window.vent.on('pageLoadComplete', this._onPageLoadComplete, this);
	}

	_removeListeners(){

	}

	// element event listeners

	_onNextClick(){
		let newIndex = Math.max(Math.min(this.getPageIndex() + 1, this.data.pages.length-1), 0);
		window.vent.trigger('changeRoute', {route:this.data.pages[newIndex].id});
	}

	_onPrevClick(){
		let newIndex = Math.max(Math.min(this.getPageIndex() - 1, this.data.pages.length-1), 0);
		window.vent.trigger('changeRoute', {route:this.data.pages[newIndex].id});
	}

	_onSilentRoute(e, params){

		let route = params.route;

		if(route && $('.modaal-wrapper').length){

			let routeObj = route.split('/');
			let pageId = routeObj[0];
			let sectionId = routeObj[1] || '';

			window.vent.trigger('closeModal');

			this._scrollToSection(sectionId);
		}
	}

	_onHeroChangeRoute(e, params){

		this.isScrollSwap = true;

		this.$contentController.addClass('is-scroll-swap');
		this.$heroController.addClass('is-scroll-swap');

		// window.RENGINE.reset();

		$(window).off('mousewheel', $.proxy(this._killMouseWheel, this));
		$(window).on('mousewheel', $.proxy(this._killMouseWheel, this));
	}

	_onLinkChangeRoute(e, params){

		this.isScrollSwap = false;

		this.$contentController.removeClass('is-scroll-swap');
		this.$heroController.removeClass('is-scroll-swap');

		// window.RENGINE.reset();

		$(window).off('mousewheel', $.proxy(this._killMouseWheel, this));
		$(window).on('mousewheel', $.proxy(this._killMouseWheel, this));
	}

	_onChangePageContent(e, params){

		if(typeof(params) !== 'undefined' && params.id){
			this._changePageById(params.id, params.sectionId);
		}
	}

	_onPageChangeStart(e, params){

		$('body').removeClass('page-loaded');
		$('body').addClass('page-loading');

		this._progressBarInit();
	}

	_onPagePopulate(e, params){

	}

	_onPagePopulateComplete(e, params){
		window.vent.trigger('windowResize');
	}

	_onPageTransitionInComplete(){

	}

	_onPageTransitionOutComplete(){
		// $('body').removeClass('page-loaded');
		// $('body').addClass('page-loading');
	}

	// initial template loading

	_loadSiteTemplates(){

		let	WS = window.SETTINGS;
		let loader = new Loader();
		let isFirstLoad = true;

		$('body').addClass('site-loading');

		let onLoadComplete = () => {

			if(isFirstLoad){

				isFirstLoad = false;

				this._progressBarComplete().then(() => {

					$('body').removeClass('site-loading');
					$('body').addClass('sk-ready site-loaded');
					window.vent.trigger('siteLoadComplete');

					this._setFirstRoute();
				});
			}
		}

		let loadCallback = (params) => {
			this._progressBarUpdate(params.progress);
			if(params.success && params.loadItem && params.loadItem.obj){
				params.loadItem.obj.template = params.data;
				if(params.loadItem.isModal){
					$('#modal-templates').append(params.data);
				}
			}
		}

		let loadTemplatesByType = (array, folderName, fileName, isModal) => {
			for(let i=0; i<array.length; i++){
				loader.addToQueue({
					id: array[i].id,
					obj: array[i],
					url: '/' + folderName + '/' + array[i].id + '/' + fileName,
					callback: loadCallback,
					pushToFront: true,
					isModal: (isModal === true)
				});
			}
		}

		loader = new Loader({
			autoStart: false,
			onCompleteCallback: onLoadComplete
		});

		loadTemplatesByType(WS.templates.content, 'page-templates', 'index.html');
		loadTemplatesByType(WS.templates.heroes, 'hero-templates', 'index.html');
		loadTemplatesByType(WS.templates.modals, 'modal-templates', 'index.html', true);

		loadTemplatesByType(_.findWhere(WS.templates.content, {id:'action'}).sections, 'page-templates/action', 'index.html');
		loadTemplatesByType(_.findWhere(WS.templates.heroes, {id:'action'}).sections, 'hero-templates/action', 'index.html');

		this._progressBarInit();
		loader.start();
	}

	// progress bar status updates

	_progressBarInit(){

		this.loadTimeStart = (new Date()).getTime();
		this.$progressBar.addClass('is-loading');

		TweenMax.killTweensOf([this.$progressBar, this.$progressBarInner], {y: false});
		TweenMax.set(this.$progressBar, {clearProps: 'opacity'});
		TweenMax.set(this.$progressBarInner, {clearProps: 'all'});
		TweenMax.to(this.$progressBarInner, 0.4, {x:window.SETTINGS.coords.viewportWidth * (-0.9), ease:'fade'});
		TweenMax.to(this.$progressBar, 0.4, {opacity:1, ease:'fade'});
	}

	_progressBarUpdate(progress, animationTime){

		if(typeof(animationTime) === 'undefined'){ animationTime = 3; }

		if(!isNaN(progress)){
			TweenMax.killTweensOf(this.$progressBarInner, {x:true});
			TweenMax.to(this.$progressBarInner, animationTime, {x:window.SETTINGS.coords.viewportWidth * (progress * 0.9 + 0.1 - 1), ease:'progressSlide'});
		}
	}

	_progressBarComplete(minLoadTime){

		if(typeof(minLoadTime) === 'undefined'){ minLoadTime = 0; }

		let endTime = (new Date()).getTime();
		let loadTimeRemaining = Math.max(minLoadTime - (endTime - this.loadTimeStart), 200);

		return new Promise((resolve, reject) => {

			if(this.loadTimeout){
				window.clearTimeout(this.loadTimeout);
			}

			this._progressBarUpdate(1, 0.3);

			this.loadTimeout = window.setTimeout(() => {

				TweenMax.to(this.$progressBar, 0.5, {opacity:0, delay:0.2, ease:'fade', onComplete:() => {
					this.$progressBar.removeClass('is-loading');
				}});

				window.clearTimeout(this.loadTimeout);
				this.loadTimeout = null;

				resolve();

			}, loadTimeRemaining);
		});
	}

	// page loading

	_onPageLoadStart(){
		// this._progressBarInit();
	}

	_onPageLoadUpdate(e, params){
		this._progressBarUpdate(params.progress);
	}

	_onPageLoadComplete(){

		this._progressBarComplete(this.minLoadTime).then(() => {

			let routeObj = window.SETTINGS.router.getRouteObj();
			let pageSections = window.SETTINGS.pageSections[routeObj.pageId];

			if(pageSections.scrollSections) {

				$('body').addClass('page-loaded');
				$('body').removeClass('page-loading');

				this._scrollToSection(routeObj.sectionId);

				window.setTimeout(() => {
					window.vent.trigger('pageChangeComplete', {pageId: this.pageId, sectionId: this.sectionId});
				}, 500);
			}
			else {

				$('body').addClass('page-loaded');
				$('body').removeClass('page-loading');

				window.setTimeout(() => {
					window.vent.trigger('pageChangeComplete', {pageId: this.pageId, sectionId: this.sectionId});
				}, 500);
			}
		});
	}

	// transition methods

	_killMouseWheel(e){
		console.log("_killMouseWheel (mousewheel locked)");
		e.preventDefault();
	}

	_onPageChangeComplete(){

		console.log("_onPageChangeComplete");

		// slide to content area (below hero)

		if(this.isScrollSwap){
			window.vent.trigger('scrollTo', {scrollTop: window.SETTINGS.coords.winHeight});
			window.setTimeout(() => {
				$(window).off('mousewheel', $.proxy(this._killMouseWheel, this));
				window.vent.trigger('heroChangeRouteComplete');
				window.vent.trigger('windowResize');
			}, 500);
		}
		else {
			$(window).off('mousewheel', $.proxy(this._killMouseWheel, this));
		}

		//

		this.isScrollSwap = false;
		this.$contentController.removeClass('is-scroll-swap');
		this.$heroController.removeClass('is-scroll-swap');

		window.SETTINGS.animationFrame.one(() => {
			window.vent.trigger('windowResize');
		});
	}

	_scrollToSection(sectionId){

		$(window).off('mousewheel', $.proxy(this._killMouseWheel, this));
		$(window).on('mousewheel', $.proxy(this._killMouseWheel, this));

		let seekScroll = () => {

			window.vent.off('modalClose', seekScroll, this);
			window.SETTINGS.animationFrame.one(() => {

				let $sectionContent = sectionId ? $(`[data-content-id=\"${sectionId}\"]`) : null;
				let sectionTop = ($sectionContent && $sectionContent.length) ? $sectionContent.offset().top : 0;

				window.vent.trigger('cancelScroll');
				window.vent.trigger('scrollTo', {scrollTop: sectionTop});

				window.setTimeout(() => {
					$(window).off('mousewheel', $.proxy(this._killMouseWheel, this));
				}, 500);
			});
		}

		if($('.modaal-noscroll').length){
			window.vent.on('modalClose', seekScroll, this);
		}
		else {
			seekScroll();
		}
	}

	//

	_changePageById(id, sectionId){

		id = this._cleanId(id);

		let curPageId = this.pageId;
		let curSubsectionId = this.sectionId;
		let curPageObj = curPageId ? _.findWhere(this.data.pages, {id:curPageId}) : {};
		let nextPageObj = _.findWhere(this.data.pages, {id:id});
		let lastPageId = this.pageId;
		let lastSectionId = this.sectionId;

		let pageSections = window.SETTINGS.pageSections[id];

		console.log('_changePageById', id, sectionId, 'firstPage', this.isFirstPage);

		if(id && (id !== curPageId || (id === curPageId && sectionId !== curSubsectionId) || (id == curPageId && pageSections.scrollSections) || this.isFirstPage) && nextPageObj && !this.isTrans){

			let wasFirstPage = this.isFirstPage;

			this.pageId = id;
			this.sectionId = sectionId;
			this.pageIndex = this.data.pages.indexOf(nextPageObj);
			this.isFirstPage = false;

			if(id === curPageId && pageSections.scrollSections && !wasFirstPage){

				// scroll to content

				if(!sectionId){
					sectionId = pageSections.sections[0].id;
				}

				if($('.modaal-wrapper').length){
					let onModalClose = () => {
						window.vent.off('modalClose', onModalClose);
						this._scrollToSection(sectionId);
					}

					window.vent.on('modalClose', onModalClose);
				}
				else {
					this._scrollToSection(sectionId);
				}
			}
			else {

				// swap content

				let swapSectionId = sectionId;

				if(pageSections.scrollSections){
					swapSectionId = '';
				}

				window.vent.trigger('pageChangeStart', nextPageObj);

				// transition methods

				let transOut = () => {

					window.vent.trigger('pageTransitionOut', nextPageObj);

					this.heroController.transOutContent(id, swapSectionId, this.isScrollSwap).then(() => {
						this.contentController.transOutContent(id, swapSectionId, this.isScrollSwap).then(() => {
							transOutComplete();
						});
					});
				}

				let transOutComplete = () => {
					window.vent.trigger('pageTransitionOutComplete', curPageObj);
					populatePage();
				}

				let populatePage = () => {

					window.vent.trigger('pagePopulate', nextPageObj);

					this.heroController.swapContentById(id, swapSectionId, this.isScrollSwap).then(() => {
						this.contentController.swapContentById(id, swapSectionId, this.isScrollSwap).then(() => {
							populatePageComplete();
						});
					});
				}

				let populatePageComplete = () => {
					window.vent.trigger('pagePopulateComplete', nextPageObj);
					transIn();
				}

				let transIn = () => {

					window.vent.trigger('pageTransitionIn', nextPageObj);

					this.heroController.transInContent(id, swapSectionId, this.isScrollSwap).then(() => {
						this.contentController.transInContent(id, swapSectionId, this.isScrollSwap).then(() => {
							transInComplete();
						});
					});
				}

				let transInComplete = () => {

					window.vent.trigger('pageTransitionInComplete', nextPageObj);

					// if page has changed somehow, change content

					this.isTrans = false;

					if(this.getPageId() !== id){
						this._changePageById(this.getPageId());
					}
					else if(wasFirstPage){
						this._onPageLoadComplete(true);
					}
				}

				// don't trans out first page

				if(this.pageIndex >= 0){

					if(wasFirstPage){
						window.vent.trigger('pageTransitionOutComplete', curPageObj);
						populatePage();
					}
					else if(curPageId){
						this.isTrans = true;
						transOut();
					}
				}
				else {
					console.log("ERROR - Invalid Page Index");
				}
			}
		}

		// update page class

		let routeObj = window.SETTINGS.router.getRouteObj();

		if(routeObj){
			$('body').removeClass('page-' + lastPageId);
			$('body').removeClass('section-' + lastSectionId);
		}

		$('body').addClass('page-' + routeObj.pageId);

		if(routeObj.sectionId){
			$('body').addClass('section-' + routeObj.sectionId);
		}

		// update page title

		let pageTitle = window.SETTINGS.pageSections[routeObj.pageId].title;
		let sectionObj = routeObj.sectionId ? _.findWhere(window.SETTINGS.pageSections[routeObj.pageId].sections, {id: routeObj.sectionId}) : null;
		let sectionTitle = sectionObj ? sectionObj.title : '';

		if(sectionTitle){
			pageTitle += ' - ' + sectionTitle;
		}

		document.title = pageTitle;
	}

	_changePageByIndex(index){

		if(index !== this.pageIndex && index >= 0 && index < this.data.pages.length){

			let id = this.data.pages[index].id;
			if(id){
				this._changePageById(id);
			}
		}
	}

	_setFirstRoute(){
		let routeObj = window.SETTINGS.router.getRouteObj();
		this._changePageById(routeObj.pageId, routeObj.sectionId);
	}

	_updateArrowStatus(){

		// prev arrow

		if(this.getPageIndex() <= 0){
			this.$prevArrow.removeClass('is-showing');
		}
		else {
			this.$prevArrow.addClass('is-showing');
		}

		// next arrow

		if(this.getPageIndex() >= this.data.pages.length){
			this.$nextArrow.removeClass('is-showing');
		}
		else {
			this.$nextArrow.addClass('is-showing');
		}
	}

	_cleanId(id){
		if(id){
			if(id.charAt(0) === '/'){ id = id.substr(1); }
			return id.split('/')[0];
		}
		return null;
	}

	getPageId(){
		return this._cleanId(window.SETTINGS.router.getRouteObj().pageId);
	}

	getPageIndex(){
		let pageIndex = this.data.pages.indexOf(_.findWhere(this.data.pages, {id: this.getPageId()}));
		return isNaN(pageIndex) ? 0 : pageIndex;
	}

	//

	_domUpdate(){ } // use me!
	_resize(){ } // use me!
}

module.exports = SiteController;
